export function isArray(arr) {
    return Array.isArray(arr);
}
//# sourceMappingURL=isArray.js.map